import styled from '@emotion/styled'

export const StyledBabyPoopDetail = styled.div`
  .inline-button {
    display: flex;
    gap: 8px;
    justify-content: center;
    .grow {
      width: 100%;
      flex-grow: 1;
    }
    .share span {
      display: flex;
      align-items: center;
    }
  }
`

export const StyledBabyPoopDetailImageWrapper = styled.div`
  position: relative;
  overflow: hidden;
  height: 380px;
`

export const StyledBabyPoopDetailPoopImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 300ms;
  filter: blur(0);

  [data-is-blurred='true'] & {
    filter: blur(12px);
  }
`

export const StyledBabyPoopDetailImageFloatContent = styled.div`
  position: absolute;
  gap: 12px;
  display: flex;

  bottom: 50%;
  left: 48px;
  right: 48px;
  transform: translateY(50%);

  &,
  * {
    transition: all 300ms;
  }

  svg {
    flex-shrink: 0;
  }

  * {
    opacity: 1;
    transform: scale(1);
    transform-origin: bottom left;
  }

  [data-is-blurred='false'] & {
    bottom: 12px;
    left: 0px;
    transform: translateY(0);

    svg {
      width: 0;
    }

    svg,
    p {
      opacity: 0;
      transform: scale(0);
    }
  }
`

export const StyledBabyPoopDetailMainColumn = styled.div`
  padding-bottom: 40px;
`
export const StyledBabyPoopDetailBackButton = styled.a`
  display: block;
  width: fit-content;
  margin: auto;
  text-decoration: none;
`
